<ng-container *ngFor="let route of routes" >
    <ng-container *ngIf="route.id == selected_route" >
        <a class="btn btn-outline-secondary" routerLink="/routes/status/{{route.id}}">
            <div class="route-selection-status" style="cursor: pointer;">
              <span [ngClass]="{'icon-inactive': route.isalert === false}">
                <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
              </span>
              <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                  <img class="status-icons" alt="Advisories status icon" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                  <img class="status-icons" alt="Detour weather status icon" src="../../../assets/images/route-status/weather-icon.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                  <img class="status-icons" alt="Detour status icon" src="../../../assets/images/route-status/detour.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                  <img class="status-icons" alt="Elevator status icon" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </a>
    </ng-container>
</ng-container>